import { isRSAA, isValidRSAA, RSAA } from 'redux-api-middleware';

export const headers = (clientContext) => ({
	'x-bpi-service-context': 'USER',
	'Content-Type': 'application/json',
	'X-TS-AJAX-Request': true,
	'x-bpi-client-context': process.env.NODE_ENV === 'development' ? JSON.stringify(clientContext) : clientContext,
});

const isAllowedDuringApiCall = (action) =>
	typeof action === 'function' || !!(action && action.meta && action.meta.allowedDuringApiCall);

const createApiHeaderMiddleware = (getClientContext) => (store) => (next) => (action) => {
	if (!isRSAA(action)) {
		const { api } = store.getState();
		/* eslint-disable no-console */
		if (!isAllowedDuringApiCall(action) && api && api.callsInProgress.length > 0) {
			console.log(`Api call in progress - unable to process action: ${action.type}`);
			if (console.table) console.table(api.callsInProgress);
			return {};
		}
		/* eslint-enable no-console */
		return next(action);
	}

	const clientContext = getClientContext(store.getState(), action);
	let nextAction;

	if (
		isValidRSAA(action) &&
		action[RSAA].types[0] &&
		action[RSAA].types[0].meta &&
		action[RSAA].types[0].meta.noAuthApiHeaders
	) {
		nextAction = action;
	} else {
		nextAction = {
			[RSAA]: {
				...action[RSAA],
				headers: {
					...headers(clientContext),
					...action[RSAA].headers,
				},
			},
		};
	}

	return next(nextAction);
};

export default createApiHeaderMiddleware;
